import React from 'react'
import spinner from 'assets/img/loaders/loader.svg'

const Button = props => {
  if (props.loading === true) {
    return (
      <img className={`${props.htmlClass}`} src={spinner} alt="spinner" style={{width: '50px'}}/>
    )
  } else {
    return (
      <button id="submit_profile" className={`${props.htmlClass} btn form-submit`}>
        {props.children}
      </button>
    )
  }
}

export default Button
